import { WebShopProductListData } from '../../../../../app/data/model';
import List from '../../../../../app/shared/components/List/List';
import HeaderLevel2 from '../../../../../app/shared/components/Typography/HeaderLevel2';
import css from './ProductList.css';
import ProductThumbnail from './ProductThumbnail/ProductThumbnail';
import ProductThumbnailState from './ProductThumbnail/ProductThumbnailState';

interface ProductListProps {
  items: ProductThumbnailState[];
  title?: string;
  onItemClick?: (item: WebShopProductListData, index: number) => void;
}

const ProductList = ({ items, onItemClick, title }: ProductListProps) => {
  const getOnItemClickHandler = (item: WebShopProductListData, index: number) =>
    onItemClick ? () => onItemClick(item, index) : undefined;

  return (
    <section className={css.container}>
      {title && (
        <HeaderLevel2 className={css.title} centered>
          {title}
        </HeaderLevel2>
      )}
      <List
        className={css.list}
        itemClassName={css.item}
        items={items}
        itemRenderer={(item, index) => (
          <ProductThumbnail state={item} onClick={getOnItemClickHandler(item.product, index)} />
        )}
      />
    </section>
  );
};

export default ProductList;
